import { COLORS } from '../constants/theme';

export const drawHeader = (engine, { logoImgData, orderNumber }) => {
    const doc = engine.getDoc();

    // Extract base64 URL whether logoImgData is string or object
    const logoBase64 = typeof logoImgData === 'string' ? logoImgData : logoImgData?.base64;

    // Logo left
    if (logoBase64) {
        try {
            const maxWidth = 60;
            const maxHeight = 45;
            const width = logoImgData?.width || 60;
            const height = logoImgData?.height || 45;
            const ratio = width / height;
            let renderWidth = maxWidth;
            let renderHeight = maxHeight;

            if (ratio > maxWidth / maxHeight) {
                renderWidth = maxWidth;
                renderHeight = maxWidth / ratio;
            } else {
                renderHeight = maxHeight;
                renderWidth = maxHeight * ratio;
            }

            const xOffset = 36;
            const yOffset = 25 + (maxHeight - renderHeight) / 2;

            doc.addImage(logoBase64, 'PNG', xOffset, yOffset, renderWidth, renderHeight);
        } catch (e) {
            console.error("Failed to add logo to PDF: ", e);
        }
    }

    // Company info left next to logo
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(...COLORS.TEXT_MAIN);
    doc.text("Kinderland Inc", 110, 38);

    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(9.5);
    doc.setTextColor(...COLORS.TEXT_MUTED);
    doc.text("800 N Federal Hwy, Suite 903 • Hallandale, FL 33009", 110, 50);
    doc.text("Phone: (305) 477-4011 • Email: Danny@venettini.com", 110, 62);

    // PO Title and Number right
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(21);
    doc.setTextColor(...COLORS.TEXT_MAIN);
    doc.text("PURCHASE ORDER", 576, 38, { align: 'right' });
    doc.setFontSize(13);
    doc.text(`PO# ${orderNumber}`, 576, 56, { align: 'right' });

    // Double separator line under header
    doc.setDrawColor(...COLORS.LINE_DARK);
    doc.setLineWidth(1.5);
    doc.line(36, 75, 576, 75);
    doc.setLineWidth(0.5);
    doc.line(36, 78, 576, 78);

    return 78;
};
